import styled from "@emotion/styled";
import theme from "@theme";

const BodyHeader = styled.div`
  padding: 16px 24px;
  background: ${theme.gradient.modernGlass};
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  position: fixed;
  width: 100%;
  z-index: 1000;
  box-shadow: ${theme.modernTokens.shadows.sm};
`;

const BodyContainer = styled.div`
  margin-top: 60px;
`;

const FilterContainer = styled.div`
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  padding: 16px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
`;

const LeasingLayout = styled.div`
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const HeaderLeft = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const Title = styled.p`
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  padding: 0;
  margin: 0;
`;

const SC = {
  BodyHeader,
  BodyContainer,
  FilterContainer,
  LeasingLayout,
  HeaderLeft,
  Title,
};

export default SC;
